import script from "./StatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StatCard.vue?vue&type=script&setup=true&lang=js"

import "./StatCard.vue?vue&type=style&index=0&id=04cd0f75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04cd0f75"]])

export default __exports__